import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-pro-wa-icon-fa',
	templateUrl:'./WaIconFAProPage.html',
	styles: [],
	styleUrls:['./WaIconFAProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaIconFAProPage
{
	mdContent_351 = `\`\`\`java
import com.jwebmp.webawesomepro.components.page.faicon.WaIconFA;
\`\`\``;
	mdContent_352 = `\`\`\`java
new WaIconFA<>()
\`\`\``;
	mdContent_353 = `\`\`\`java
new WaIconFA<>(IFontAwesomeIcon iconName)
\`\`\``;
	mdContent_354 = `\`\`\`java
new WaIconFA<>(IFontAwesomeIcon iconName, FontAwesomeStyles family)
\`\`\``;
	mdContent_355 = `\`\`\`java
new WaIconFA<>(String iconName, FontAwesomeStyles family, IconVariant variant)
\`\`\``;
	mdContent_356 = `\`\`\`java
var icon = new WaIconFA<>(FontAwesome5ProIcons.user);
\`\`\``;
	mdContent_357 = `\`\`\`java
var icon = new WaIconFA<>(FontAwesome5ProIcons.heart, FontAwesomeStyles.Light);
\`\`\``;
	mdContent_358 = `\`\`\`java
var icon = new WaIconFA<>("bell", FontAwesomeStyles.Duotone, IconVariant.Solid);
\`\`\``;
}
